module.exports = __webpack_public_path__ + "static/img/rank03.183e115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/rank03.jpg
// module id = smTz
// module chunks = 76